import React, { useState, useEffect, useContext } from 'react';
import Cookies from 'js-cookie';

import Dropdown from '../common/Dropdown'

import createCampaign from '../../helpers/createCampaign.js';
import getCampaignData from '../../helpers/getCampaignData.js';

import { DEFAULT_CAMPAIGN } from '../../globals.js';
import { sanitizeCampaignName } from '../../helpers/sanitizeInput.js';
import { UserDataContext } from "../../App.js";
import './CampaignMenu.css';

// ----------------------------------------------------------------------------------
//                         Description
//
//     CampaignMenu is a dropdown menu that allows the user to select a campaign.
//
//     (c) DXA Development 2025
// ----------------------------------------------------------------------------------

function CampaignMenu(props) {
    // ------------ parameters ---------------


    // ------ inherited state variables ------
    const [userData, setUserData] = useContext(UserDataContext);
    const userDef = `currentCampaign: "",
                     dynamoData: Object { characterCount: 0, username_alias: "Doc Sonic", role: "admin", … },
                     loggedIn: true, 
                     uniqueUser: "",
                     username: ""
                     `;

    const globalState = props.state;
    const setChar = globalState[1];
    const statedef = `/* 0 */ currentChar,
                          /* 1 */ setChar,
                          /* 2 */ loggedIn,
                          /* 3 */ layout, 
                          /* 4 */ setLayout, 
                          /* 5 */ currentSpellArray, 
                          /* 6 */ currentSpellDataArray, 
                          /* 7 */ allSpellsArray,
                          /* 8 */ musicPlayingArray ];`


    // -------- local state variables --------
    const [campaignList, setCampaignList] = useState([DEFAULT_CAMPAIGN, "camp001", "camp002", "camp003","Create New"]);

    // -------- GET CAMPAIGN LIST -----------
    useEffect(() => {
        // get the campaign list from the user data
        const campaignList = userData.dynamoData.campaigns;
        console.log('Campaign list:', campaignList);
        let campaignNames = Object.keys(campaignList);
        campaignNames.push("Create New");
        setCampaignList(campaignNames);
    }, [userData]);


    // -------- DEFINE CLICK HANDLER --------
    const handleClick = async (campaign) => {

        let selectedCampaign = campaign;

        // ----- CREATE NEW CAMPAIGN -----
        if (campaign === "Create New") {
            // create a new campaign
            const newCampaignRaw = prompt("Enter the name of the new campaign:");
            const newCampaign = newCampaignRaw ? sanitizeCampaignName(newCampaignRaw) : null;
            if (newCampaign !== null && newCampaign !== "") {
                const createCampaignResult = await createCampaign(newCampaign, userData, setUserData);
                if (createCampaignResult === 'Error: User has reached the maximum number of campaigns') 
                    return;
                if (createCampaignResult === 'Error: Campaign already exists') 
                    return;
                
                // newCampaign goes next to last campaign in the list
                let newCampaignList = [...campaignList];
                newCampaignList.splice(newCampaignList.length - 1, 0, newCampaign);
                setCampaignList(newCampaignList);
                
                console.log('New campaign created:', newCampaign);

                selectedCampaign = newCampaign;

                // ask user if they want to clear the character sheet
                const clearSheet = window.confirm("Do you want to clear the character sheet?");
                if (clearSheet) {
                    setChar('blank');
                }

            } else {
                alert('No campaign name entered');
                return;
            }   
        }

        Cookies.set('currentCampaign', selectedCampaign, { expires: 3650 });
        console.log('Selected campaign:', selectedCampaign);

        const newCampaignData = await getCampaignData(selectedCampaign);
        let newUserData = { ...userData };
        newUserData.currentCampaign = selectedCampaign;
        newUserData.campaignData = newCampaignData;
        setUserData(newUserData);

        // hide the settings menu
        
        const settingsMenu = document.querySelector('.settings-menu');
        if (settingsMenu) {
            settingsMenu.style.display = 'none';
        }
    }



    // -------- RETURN JSX -----------

    return (
        <Dropdown
            trigger={<button className="nav-settings-button">Change Campaign</button>}
            menu={campaignList.map((campaign, index) => (
            <button
                key={index}
                id={campaign === userData.currentCampaign ? "current-campaign" : `campaign-${index}`}
                className="dropdown-item"
                onClick={() => handleClick(campaign)}
            >
                {campaign}
            </button>
        ))}
            divClass="menu-item sub-menu"
            menuClass="menu"
            onChildClose={props.onChildClose}
        />
    );
}
export default CampaignMenu;

